import React from 'react'

export default function UpdateReq() {
  return (
    <div>UpdateReq</div>
  )
}
